import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { ReservationCompareStore } from '../service/reservation-compare-store';
import { ReservationCompare } from '../models/reservation-compare';
import { LogService } from '../../shared/log/log.service';

@Injectable()
export class ReservationCompareResolver implements Resolve<any> {
  private previousRoute: string = null;

  constructor(private reservationCompareStore: ReservationCompareStore,
              private translateService: TranslateService,
              private logService: LogService,
              private router: Router) {
    // This code is required in order to know the previous route in resolve.
    // Note that first the NavigationStart event will happen, then resolve() is called if the resolver is attached
    // to the route, then NavigationEnd happens.
    this.router.events
      .filter(e => e instanceof NavigationEnd)
      .subscribe((e: NavigationEnd) => {
        this.previousRoute = e.url;
      });
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<ReservationCompare>> {
    const id = route.params[ 'id' ];

    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.RESERVATION_COMPARE'));
    }

    // Reset the filters unless the last route was reservations summary or detail
    // Note that this resolve happens before the NavigationEnd event for the route we're about to go to,
    // so we can find the last route that was navigated to successfully by checking the last NavigationEnd event.
    if (this.previousRoute && !this.previousRoute.includes(`/${id}/reservations`)) {
      this.reservationCompareStore.resetStatusCodes();
    }

    return this.reservationCompareStore.getReservations(route.params['id']);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/reservation.compare.resolver.ts